import * as types from '../types/searchTypes';
import * as searchService from '../../services/searchService';

export const searchMulti = (query, page = 1, { language } = {}) => async (dispatch) => {
  if (!String(query || '').trim()) {
    dispatch({ type: types.SEARCH_CLEAR });
    return;
  }
  const q = String(query).trim();
  dispatch({ type: types.SEARCH_MULTI_REQUEST });
  try {
    const data = await searchService.searchMulti(q, page, { language });
    dispatch({ type: types.SEARCH_MULTI_SUCCESS, payload: data.results || [] });
  } catch (err) {
    dispatch({
      type: types.SEARCH_MULTI_FAILURE,
      payload: err?.response?.data?.error || err?.message || 'Search failed',
    });
  }
};

export const clearSearch = () => ({ type: types.SEARCH_CLEAR });
